module.exports = __webpack_public_path__ + "img/rjc.0f8c49e.webp";